import * as React from 'react';
import {useEffect, useRef} from 'react';

import {STATUS_REDUCER_STATE_ID} from '../status_constants';
import {statusSlice} from '../status_slice';
import {BackendInfoResponse} from '../status_types';
import {ConfigObjectType} from 'src/js/common';
import {useApiQuery} from 'src/js/hooks/useApiQuery';
import {useAppDispatch, useAppSelector} from 'src/js/store_hooks';

interface OwnProps {
  config: ConfigObjectType;
}

type Props = OwnProps;

export const BackendInfoContainer: React.FC<Props> = (props) => {
  const {config} = props;

  const dispatch = useAppDispatch();
  const backendInfo = useAppSelector(
    (state) => state[STATUS_REDUCER_STATE_ID].backendInfo
  );

  const scriptNodeRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    if (!scriptNodeRef.current) {
      scriptNodeRef.current = document.createElement('script');
      scriptNodeRef.current.setAttribute('id', 'backendInfo');
      scriptNodeRef.current.setAttribute('type', 'application/javascript');
      document.head.appendChild(scriptNodeRef.current);
    }

    return () => {
      if (scriptNodeRef.current && scriptNodeRef.current.remove) {
        scriptNodeRef.current.remove();
      }
    };
  }, []);

  const {data} = useApiQuery<BackendInfoResponse>(
    [config.service.url.info],
    null,
    {
      axiosConfig: {url: config.service.url.info},
      reactQueryOptions: {
        enabled: !backendInfo,
      },
    }
  );

  useEffect(() => {
    dispatch(statusSlice.actions.setBackendInfo({backendInfo: data}));
    if (scriptNodeRef.current) {
      scriptNodeRef.current.text = `var backendInfo = ${JSON.stringify(
        data,
        null,
        2
      )};`;
    }
  }, [data, dispatch]);

  return null;
};

BackendInfoContainer.displayName = 'BackendInfoContainer';
